export const maskNumberPhone = (phone) =>
  phone?.toString()?.replace(/(\d\d\d)(\d\d\d)(\d\d)/, '+7 ($1) $2 $3');
